// @core/stores/payment/PaymentPaymentTypeStore.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { makeAutoObservable, runInAction } from 'mobx';
import { paymentApi } from '@core/api';
import type {
  ListPaymentTypesResponse,
  PaymentTypeDefinitionResponse,
  RegisterPaymentTypeRequest,
  UpdatePaymentTypeRequest,
} from '@core/types/payment';

class PaymentPaymentTypeStore {

  // Loading states
  isLoading = false;

  // Error state (stores full ApiClientError for request context)
  error: unknown = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Actions
  setError(error: unknown): void {
    this.error = error;
  }

  clearError(): void {
    this.error = null;
  }

  reset(): void {
    this.error = null;
  }

  /**
   * Delete payment type
   */
  async DeletePaymentType(type_id: string): Promise<Response> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await paymentApi.DeletePaymentType(type_id);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Get payment type
   */
  async GetPaymentType(type_id: string): Promise<PaymentTypeDefinitionResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await paymentApi.GetPaymentType(type_id);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * List payment types
   */
  async ListPaymentTypes(params?: { cursor?: string | number | boolean; direction?: string | number | boolean; limit?: string | number | boolean; product_id?: string | number | boolean; sort?: string | number | boolean; }): Promise<ListPaymentTypesResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await paymentApi.ListPaymentTypes(params);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Register payment type
   */
  async RegisterPaymentType(data: RegisterPaymentTypeRequest): Promise<PaymentTypeDefinitionResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await paymentApi.RegisterPaymentType(data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Update payment type
   */
  async UpdatePaymentType(type_id: string, data: UpdatePaymentTypeRequest): Promise<PaymentTypeDefinitionResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await paymentApi.UpdatePaymentType(type_id, data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }
}

export const paymentPaymentTypeStore = new PaymentPaymentTypeStore();
